import { axiosBaseQuery } from "@king-ict/eupisi-ui/utils";
import { createApi } from "@reduxjs/toolkit/query/react";

import {
  AdditionalDocumentationDto,
  InstitutionSelectionDto,
  RequestSummaryDto,
  PersonDetails,
} from "../models/Request";

const requestsUrlPrefix: string = "requests";

export const requestApi = createApi({
  reducerPath: "requestApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (build) => ({
    getRequestSummary: build.query<RequestSummaryDto, number>({
      query: (requestId) => `${requestsUrlPrefix}/summary/${requestId}`,
    }),
    getPersonDetails: build.query<PersonDetails, number>({
      query: (personDetailsId) =>
        `${requestsUrlPrefix}/person-details/${personDetailsId}`,
    }),
    getInstitutionSelection: build.query<InstitutionSelectionDto, number>({
      query: (requestId) =>
        `${requestsUrlPrefix}/institution-selection/${requestId}`,
    }),
    getAdditionalDocumentation: build.query<AdditionalDocumentationDto, number>(
      {
        query: (requestId) =>
          `${requestsUrlPrefix}/additional-documentation/${requestId}`,
      }
    ),
  }),
});

export const {
  useGetRequestSummaryQuery,
  useLazyGetRequestSummaryQuery,
  useLazyGetPersonDetailsQuery,
  useLazyGetInstitutionSelectionQuery,
  useLazyGetAdditionalDocumentationQuery,
} = requestApi;
